import { Wrapper } from 'models/wrapper';
import type { SecondaryMarketTabTarget } from 'state/secondaryMarket/secondaryMarket.thunks';
import { secondaryMarketOrderOpenNewOrderTabFromIsinOrBcsKeyThunk } from 'state/secondaryMarket/secondaryMarket.thunks';
import { bcsProductKeyToString } from 'state/secondaryMarket/utils';
import type { Thunk } from 'state/state.common';

import { tradeAllocationApplyRequested, tradeAllocationTabCreated } from './tradeAllocationForm.actions';
import type { BcsKey, ProductTradingOption } from './tradeAllocationForm.model';
export function tradeAllocationTabCreatedThunk(
  tradeId: string,
  tabName: string,
  product: string,
  wrapper: Wrapper,
  productId: string,
  rfqId: string,
  isin?: string,
  fileCode?: string,
): Thunk<void> {
  return (dispatch, _getState, { getNewGuid }) => {
    const tabId = getNewGuid();
    dispatch(tradeAllocationTabCreated(tabId, tradeId, tabName, product, wrapper, productId, rfqId, isin, fileCode));
  };
}

export function tradeAllocationApplyRequestedThunk(tabId: string): Thunk<void> {
  return (dispatch, _getState, { getNow, getSgmeConfiguration }) => {
    dispatch(tradeAllocationApplyRequested(tabId, getNow().getTime(), getSgmeConfiguration().tradeAllocationTimeoutMs));
  };
}

const productTradingOptionToFormType: Record<ProductTradingOption, SecondaryMarketTabTarget['formType']> = {
  ebiz: 'Ebiz screen',
  cpOrder: 'Order on close',
  limitOrder: 'Limit order',
  liveOrder: 'Live',
};
export function openInSecondaryMarketFromTradeAllocationThunk(
  option: ProductTradingOption,
  isin: string,
  bcsKey?: BcsKey,
): Thunk<void> {
  return dispatch => {
    const formType = productTradingOptionToFormType[option];
    const target: SecondaryMarketTabTarget =
      formType === 'Ebiz screen' ? { formType, isin } : { formType, bcsKey: bcsProductKeyToString(bcsKey), isin };
    dispatch(secondaryMarketOrderOpenNewOrderTabFromIsinOrBcsKeyThunk(target));
  };
}
